import { FilterOperatorType } from '../components/odata-filter/models/filter-operator-type';
import {
  FilterGroup,
  ODataFilter,
  ODataSubFilter,
} from '../components/odata-filter/models/odata-filter';
import { ODataFilterBuilder } from './odata-filter-builder';

export class SearchBoxFilterModel implements ODataFilter {
  childFieldName = '';
  targetFieldId = '';
  filterGroup = FilterGroup.SystemFields;
  values = [];
  valueType = null;
  displayName = '';
  targetField = '';
  subFilter = new ODataSubFilter();

  constructor(public targetFields: { name: string; isGuid: boolean; isEmail: boolean }[]) {}
  buildFilter(searchValue: string) {
    let filter: { [k: string]: any } = {};
    const guidValidator =
      /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    if (this.targetFields.findIndex((x) => x.isGuid) != -1 && guidValidator.test(searchValue)) {
      filter = {
        or: this.targetFields
          .filter((x) => x.isGuid)
          .map((targetField) =>
            ODataFilterBuilder.buildGuidFilter(targetField.name, searchValue, FilterOperatorType.eq)
          ),
      };
    } else if (
      this.targetFields.findIndex((x) => x.isEmail) != -1 &&
      searchValue.includes('@') &&
      searchValue.includes(';')
    ) {
      filter = {
        or: this.targetFields
          .filter((x) => x.isEmail)
          .map((targetField) =>
            ODataFilterBuilder.buildEmailFilter(
              targetField.name,
              searchValue,
              FilterOperatorType.in
            )
          ),
      };
    } else {
      filter = {
        or: this.targetFields
          .filter((x) => !x.isGuid)
          .map((targetField) =>
            ODataFilterBuilder.buildStringFilter(
              targetField.name,
              searchValue,
              FilterOperatorType.contains
            )
          ),
      };
    }
    return filter;
  }
}
